<div class="activity-details solo">
    <c-auto-form config="setOwner.autoFormConfig"></c-auto-form>
</div>